<template>
  <div class="Main video-guide-page">
    <van-nav-bar
      fixed
      :border="false"
      :title="$t('videoGuide.title')"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div class="PageBox">
      <div class="ScrollBox">
        <div class="video-card">
          <!-- <div class="brochure-bar" @click="$router.push('/information')">
            <span>{{ $t('videoGuide.brochure') }}</span>
            <van-icon name="arrow" color="#999" />
          </div> -->
          <div class="video-wrap">
            <video
              class="video-player"
              controls
              playsinline
              webkit-playsinline
              preload="metadata"
              :src="videoUrl"
              :poster="posterUrl"
            />
          </div>
        </div>
        <div class="text-card">
          <p class="description">{{ $t('videoGuide.description') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoGuide',
  data() {
    return {
      videoUrl: 'https://www.zzsgm.com/upload/video/SGM.S.mp4'
    }
  },
  computed: {
    posterUrl() {
      const logo = this.InitData && this.InitData.setting && this.InitData.setting.logo_img
      return logo || ''
    }
  }
}
</script>

<style lang="scss" scoped>
.video-guide-page {
  background: #eff8f2;
  min-height: 100%;
}

.PageBox {
  background: #eff8f2;
}

.ScrollBox {
  padding: 12px 14px 24px;
  box-sizing: border-box;
}

.video-card,
.text-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(55, 119, 76, 0.08);
}

.video-card {
  margin-bottom: 12px;
}

.brochure-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  font-size: 15px;
  color: #333;
  border-bottom: 1px solid #f0f0f0;
}

.video-wrap {
  width: 100%;
  background: #000;
}

.video-player {
  display: block;
  width: 100%;
  max-height: 220px;
  object-fit: contain;
  vertical-align: top;
}

.text-card {
  padding: 16px 14px;
}

.description {
  margin: 0;
  font-size: 14px;
  line-height: 1.7;
  color: #333;
  text-align: justify;
  white-space: pre-line;
  word-break: break-word;
}

::v-deep .van-nav-bar__content {
  background: linear-gradient(to right, $theme-shallow-color, $theme-color);
  color: #fff;
}
::v-deep .van-nav-bar__title {
  color: #fff;
}
::v-deep .van-nav-bar .van-icon {
  color: #fff !important;
}
</style>
